import { useRouter } from 'vue-router'
import { PUBLIC_URL_REG_EXP } from '@/const'
import {
  useLoadingsStore,
  useUserAPIStore,
  useWalletAPIStore,
  useWalletStore,
} from '@/stores'

/**
 * 처음 접속시 userToken 이 있는 사용자는 토큰으로 로그인 시키는 함수
 *
 * @returns
 */
export const loginUserQueryToken = async () => {
  if (PUBLIC_URL_REG_EXP.test(window.location.pathname)) return
  const router = useRouter()
  const userAPIStore = useUserAPIStore()
  const walletAPIStore = useWalletAPIStore()
  const walletStore = useWalletStore()
  const loadingStore = useLoadingsStore()

  try {
    const token = new URLSearchParams(window.location.search).get('userToken')
    if (!token) return
    loadingStore.openSpinner()
    await userAPIStore.loginWepinWithToken(token)
    await walletAPIStore.fetchWalletList()

    if (walletStore.walletList.length === 0) {
      router.replace('/signin')
    }
  } catch (e: any) {
    router.replace('/signin')
  } finally {
    loadingStore.closeSpinner()
  }
}
